module.exports = __webpack_public_path__ + "br.af9012dcb65215292386.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/br.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/br.svg
// module chunks = styles